import { ContactDataType } from "@swo/shared";
import { Wrapper } from "../../shared-components/wrapper";
import cn from "classnames";
import { ContentContainer } from "../../../../../components/_shared-components/arrangement/Container";
import React from "react";
import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";
import { css } from "@emotion/react";
import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../../../styles/styles-css-variables";
import { CustomerServiceContactData } from "../../../../../components/_shared-components/CustomerServiceContactData";
import { usePageContext } from "../../../../../global/page-context";
import { Spacer } from "../../../../../components/_shared-components/arrangement/Space";
import { PaymentStatusError } from "../../payment-status-error";
import { PCPHr } from "../../shared-components/pcp-hr";
import { XIconSvg } from "../../../../../assets";
import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import type { PurchaseConfirmationPageTranslation, TranslatedValue } from "@swo/storefront";
import { T } from "../../../../../components/T";
import type { Translated } from "../../../../../domain/translations/translations";

export const XIconWrapper: ReactTFC = () => {
  return (
    <div
      css={css`
        margin-left: auto;
        margin-right: auto;

        width: 48px;
        height: 48px;

        svg {
          width: 50%;
          height: 50%;
        }

        background-color: ${CSS_COLORS.Grey5};
        color: ${CSS_COLORS.White};
        border-radius: 100%;

        margin-bottom: 20px;
      `}
      className={"u-d-flex u-jc-center u-ai-center"}
    >
      <XIconSvg />
    </div>
  );
};

export const PurchaseConfirmationPageErrorScreen: React.FC<
  React.PropsWithChildren<{
    context: {
      orderId: string;
      orderNumber: string;
      paymentId: string;
    };
    homepageLink: string;
    t: Translated<PurchaseConfirmationPageTranslation>;
    message: string | TranslatedValue;
    cardHolderInfo: string | undefined;
    retryPayment: undefined | { link: { pathname: string; search: string }; buttonLabel: TranslatedValue };
    contactData: ContactDataType;
  }>
> = props => {
  const pageCtx = usePageContext();

  return (
    <>
      <Wrapper className={cn("expand fill-screen", "align-start")} context={props.context}>
        <ContentContainer>
          <div
            css={[
              fontColor.black,
              css`
                text-align: center;
                margin-bottom: ${CSS_SPACER_SIZES.md};
              `,
            ]}
          >
            <XIconWrapper />

            <span
              css={[
                FONTS.MinervaModern500,
                fontSize.x1,
                css`
                  margin-left: auto;
                  margin-right: auto;
                  max-width: 20em;
                `,
              ]}
              className={"u-uppercase u-d-block"}
            >
              <T>{props.t("errorOccurred.headline")}</T>
            </span>
          </div>

          <PaymentStatusError
            homepageLink={props.homepageLink}
            t={props.t}
            message={props.message}
            cardHolderInfo={props.cardHolderInfo}
            retryPayment={props.retryPayment}
          />

          {props.children ? (
            <>
              <Spacer size={"md"} />
              {props.children}
              <Spacer size={"md"} />
            </>
          ) : null}
        </ContentContainer>
      </Wrapper>

      <ContentContainer>
        {PCPHr}

        <CustomerServiceContactData
          noSpacing={false}
          contactData={props.contactData}
          headline={undefined}
          chatbotEnabled={pageCtx.pageBase.locale.chatbotEnabled}
        />

        <Spacer size={"md"} />
      </ContentContainer>
    </>
  );
};
